import React from "react";
import { useBoolean, useId } from "@uifabric/react-hooks";
import { IconButton, Stack, Callout, Label } from "@fluentui/react";

const stackTokens = {
  childrenGap: 4,
};
const iconButtonStyles = { root: { marginBottom: -3 } };
const iconProps = { iconName: "Info" };
const labelCalloutStackStyles = { root: { padding: 20 } };

const InfoLabelButton = (props) => {
  const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(
    false
  );
  const descriptionId = useId("description");
  const iconButtonId = useId("iconButton");
  const labelId = useId("label");
  return (
    <>
      <Stack horizontal verticalAlign="center" tokens={stackTokens}>
        <Label id={labelId}>{props.label}</Label>
        <IconButton
          id={iconButtonId}
          iconProps={iconProps}
          title="Info"
          ariaLabel="Info"
          onClick={toggleIsCalloutVisible}
          styles={iconButtonStyles}
        />
      </Stack>
      {isCalloutVisible && (
        <Callout
          target={"#" + iconButtonId}
          setInitialFocus
          onDismiss={toggleIsCalloutVisible}
          ariaDescribedBy={descriptionId}
          role="alertdialog"
          calloutMaxWidth={0}
          {...props.calloutProps}
        >
          <Stack
            tokens={stackTokens}
            horizontalAlign="start"
            styles={labelCalloutStackStyles}
          >
            {props.calloutChildren}
          </Stack>
        </Callout>
      )}
    </>
  );
};

export default InfoLabelButton;
